export const DISCLAIMER =
	"Educational model only. Default factors are illustrative, rounded values for classroom comparison; they are not verified EPD, PEF, or product-footprint results.";

export const GARMENT_PRESETS = [
	{ value: "tshirt", label: "T-shirt", weightGrams: 180, wears: 60 },
	{ value: "shirt", label: "Button-down shirt", weightGrams: 260, wears: 75 },
	{ value: "jeans", label: "Jeans", weightGrams: 650, wears: 120 },
	{ value: "hoodie", label: "Hoodie", weightGrams: 600, wears: 90 },
	{ value: "dress", label: "Dress", weightGrams: 420, wears: 70 },
	{ value: "jacket", label: "Light jacket", weightGrams: 900, wears: 140 },
	{ value: "custom", label: "Custom garment", weightGrams: 300, wears: 80 },
];

export const MATERIALS = [
	{
		value: "cotton",
		label: "Conventional cotton",
		factor: 5.9,
		color: "#E9B872",
		note: "Fiber cultivation, ginning, and preparation",
	},
	{
		value: "organic-cotton",
		label: "Organic cotton",
		factor: 3.8,
		color: "#B9C98A",
		note: "Illustrative lower-input cotton pathway",
	},
	{
		value: "polyester",
		label: "Virgin polyester",
		factor: 9.5,
		color: "#EF8354",
		note: "Fossil feedstock and fiber production",
	},
	{
		value: "recycled-polyester",
		label: "Recycled polyester",
		factor: 4.2,
		color: "#4F9D8C",
		note: "Illustrative mechanical-recycling pathway",
	},
	{
		value: "nylon",
		label: "Nylon",
		factor: 12.7,
		color: "#D1495B",
		note: "Polymer and fiber production",
	},
	{
		value: "viscose",
		label: "Viscose / rayon",
		factor: 5.6,
		color: "#7E6B8F",
		note: "Dissolving pulp and fiber processing",
	},
	{
		value: "linen",
		label: "Linen",
		factor: 4.5,
		color: "#8EA604",
		note: "Flax cultivation and fiber preparation",
	},
	{
		value: "hemp",
		label: "Hemp",
		factor: 3.4,
		color: "#3A7D44",
		note: "Cultivation and fiber preparation",
	},
	{
		value: "wool",
		label: "Wool",
		factor: 23.8,
		color: "#9C6644",
		note: "Animal raising, scouring, and fiber preparation",
	},
	{
		value: "silk",
		label: "Silk",
		factor: 25,
		color: "#D17B88",
		note: "Sericulture and fiber preparation",
	},
];

export const MANUFACTURING_REGIONS = [
	{
		value: "renewable",
		label: "Renewable-powered facility",
		gridFactor: 0.08,
		note: "Low-carbon electricity scenario",
	},
	{
		value: "europe",
		label: "Europe average",
		gridFactor: 0.28,
		note: "Illustrative regional grid mix",
	},
	{
		value: "united-states",
		label: "United States average",
		gridFactor: 0.38,
		note: "Illustrative regional grid mix",
	},
	{
		value: "turkey",
		label: "Türkiye average",
		gridFactor: 0.44,
		note: "Illustrative regional grid mix",
	},
	{
		value: "global",
		label: "Global average",
		gridFactor: 0.47,
		note: "Generic grid scenario",
	},
	{
		value: "china",
		label: "China average",
		gridFactor: 0.58,
		note: "Illustrative regional grid mix",
	},
];

export const TRANSPORT_MODES = [
	{
		value: "sea",
		label: "Container ship",
		factor: 0.015,
		icon: "directions_boat",
	},
	{ value: "rail", label: "Freight rail", factor: 0.03, icon: "train" },
	{ value: "truck", label: "Truck", factor: 0.12, icon: "local_shipping" },
	{ value: "air", label: "Air freight", factor: 0.6, icon: "flight" },
];

export const WASH_TEMPERATURES = [
	{ value: "cold", label: "Cold wash", energyKwh: 0.35 },
	{ value: "warm", label: "Warm wash", energyKwh: 0.65 },
	{ value: "hot", label: "Hot wash", energyKwh: 1.2 },
];

export const END_OF_LIFE_OPTIONS = [
	{
		value: "reuse",
		label: "Reuse / donation",
		factor: 0.02,
		note: "Collection and sorting only; no avoided-impact credit",
	},
	{
		value: "recycle",
		label: "Textile recycling",
		factor: 0.08,
		note: "Collection and initial recycling process",
	},
	{
		value: "landfill",
		label: "Landfill",
		factor: 0.45,
		note: "Illustrative disposal pathway",
	},
	{
		value: "incineration",
		label: "Incineration",
		factor: 1.2,
		note: "Direct and operational emissions; no energy credit",
	},
];

export const STAGE_META = [
	{ id: "materials", label: "Raw materials", shortLabel: "Materials", color: "#E9B872" },
	{ id: "manufacturing", label: "Manufacturing", shortLabel: "Making", color: "#496A81" },
	{ id: "transport", label: "Transport", shortLabel: "Transport", color: "#4F9D8C" },
	{ id: "use", label: "Use phase", shortLabel: "Use", color: "#7E6B8F" },
	{ id: "endOfLife", label: "End of life", shortLabel: "End of life", color: "#D1495B" },
];

export function createDefaultScenario() {
	return {
		garmentType: "tshirt",
		weightGrams: 180,
		materials: [
			{ material: "cotton", percentage: 70 },
			{ material: "polyester", percentage: 30 },
		],
		manufacturingRegion: "china",
		manufacturingEnergyKwhPerKg: 8.5,
		cuttingWastePercent: 15,
		transportMode: "sea",
		transportDistanceKm: 8000,
		lifetimeWears: 60,
		wearsBetweenWashes: 2,
		washTemperature: "warm",
		dryerSharePercent: 40,
		usePhaseGridFactor: 0.38,
		endOfLife: "landfill",
	};
}

export function cloneScenario(scenario) {
	return JSON.parse(JSON.stringify(scenario));
}
